import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Paper } from '@mui/material';

import ChartHeader from '../ChartHeader/ChartHeader';
import { selectTotalEnergyStatistics } from '../../selectors';

import './_totalEnergy.scss';

const formatNumberWithEmptySpace = (number) => {
  if (isNaN(number)) {
    return '...';
  }

  return number < 1000
    ? Number(number).toFixed()
    : Number(number)
        .toFixed()
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

const TotalEnergy = () => {
  const { day, week, month } = useSelector(selectTotalEnergyStatistics);

  const formattedDay = useMemo(() => formatNumberWithEmptySpace(day), [day]);
  const formattedWeek = useMemo(() => formatNumberWithEmptySpace(week), [week]);
  const formattedMonth = useMemo(() => formatNumberWithEmptySpace(month), [month]);

  return (
    <Paper className="chart__paper">
      <ChartHeader>
        <h2>Total Energy (kWh)</h2>
      </ChartHeader>
      <div className="total-energy__container">
        <div className="total-energy--main">
          <div className="total-energy__data">
            <div className="total-energy__count">{formattedDay}</div>
            <span>today</span>
          </div>
        </div>
        <div className="total-energy--additional">
          <div className="total-energy__data">
            <div className="total-energy__count">{formattedWeek}</div>
            <span>Last 7 days</span>
          </div>
          <div className="total-energy__data">
            <div className="total-energy__count">{formattedMonth}</div>
            <span>Last 30 days</span>
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default React.memo(TotalEnergy);
